import { render, staticRenderFns } from "./SwalAdmin.vue?vue&type=template&id=7cb8d470&"
import script from "./SwalAdmin.vue?vue&type=script&lang=js&"
export * from "./SwalAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb8d470')) {
      api.createRecord('7cb8d470', component.options)
    } else {
      api.reload('7cb8d470', component.options)
    }
    module.hot.accept("./SwalAdmin.vue?vue&type=template&id=7cb8d470&", function () {
      api.rerender('7cb8d470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swal/SwalAdmin.vue"
export default component.exports